import React, { useContext } from 'react';
import theme from 'assets/theme';
import { Link as RouterLink } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { UserType } from 'helpers/enums';
import { appUserContext, authContext } from 'helpers/services';
import Topbar from '../Topbar';
import UserMenu from './UserMenu';


interface IProps {
    children: React.ReactNode
}

let PrivateLayout = ({ children }: IProps) => {
    let { currentUser } = useContext(appUserContext);
    let { isLoading, isAuthenticated } = useContext(authContext);

    return (
        <>
            <Topbar>
                {isLoading === false && isAuthenticated === true &&
                    <>
                        <div style={{ flexGrow: 1 }}>
                            <Button type="link" component={RouterLink} to="/registrations">Registrations</Button>
                            {currentUser?.isSerialNumbersEditor === true &&
                                <Button type="link" component={RouterLink} to="/serialnumbers">Serial Numbers</Button>
                            }
                            {currentUser?.userType !== UserType.External &&
                                <>
                                    <Button type="link" component={RouterLink} to="/users">User Accounts</Button>
                                    <Button type="link" component={RouterLink} to="/qrcodecheck">Check QR</Button>
                                    <Button type="link" component={RouterLink} to="/productcheck">Check Product</Button>
                                    <Button type="link" component={RouterLink} to="/adminusers">Admin Users</Button>
                                </>
                            }
                        </div>
                        <div style={{ display: 'flex' }}>
                            <UserMenu />
                        </div>
                    </>
                }
            </Topbar>
            <div style={{ padding: theme.spacing(2) }}>
                {children}
            </div>
        </>
    )
}

export default PrivateLayout;